import { APITokenProvider } from "./providers/APITokenProvider";
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { IAuthenticationService } from "@eaigle/api/authService";
import DeploymentVersionPage from "./pages/DeploymentVersionPage";
import SettingsPage from "./pages/SettingsPage";
import { LoginButton, VersionPage } from "@eaigle/ui";
import { Route, Routes } from "react-router-dom";
import { ServicesProvider } from "./contexts/ServicesContext";
import { DeploymentAccessProvider } from "./contexts/DeploymentAccessProvider";
import { SettingsRoute } from "./components/SettingsRoute";

/*
Before starting this application, create a .env file with the following contents:
VITE_APP_OAUTH_CLIENT_ID=03f992e5-f11f-41e1-8e56-d75e389e00e5
VITE_APP_OAUTH_AUTHORITY=https://login.microsoftonline.com/4f717420-fb47-4e26-b662-05fa3ce1e4cc
VITE_API_OAUTH_SCOPE=api://03f992e5-f11f-41e1-8e56-d75e389e00e5/.default
VITE_BASE_URL=https://localhost:44303

Or:
VITE_APP_OAUTH_CLIENT_ID=03f992e5-f11f-41e1-8e56-d75e389e00e5
VITE_APP_OAUTH_AUTHORITY=https://login.microsoftonline.com/4f717420-fb47-4e26-b662-05fa3ce1e4cc
VITE_API_OAUTH_SCOPE=api://03f992e5-f11f-41e1-8e56-d75e389e00e5/.default
VITE_BASE_URL=https://cistaginrg-deployment.azurewebsites.net
*/

export type Props = {
  authService?: IAuthenticationService;
};

function App({ authService }: Props) {
  return (
    <>
      <AuthenticatedTemplate>
        <ServicesProvider>
          <APITokenProvider authService={authService}>
            <DeploymentAccessProvider>
              <Routes>
                <Route path="/" element={<DeploymentVersionPage />} />
                <Route
                  path="/settings"
                  element={
                    <SettingsRoute>
                      <SettingsPage />
                    </SettingsRoute>
                  }
                />
                <Route
                  path="/version"
                  element={<VersionPage appName="Deployment Version Dashboard" />}
                />
              </Routes>
            </DeploymentAccessProvider>
          </APITokenProvider>
        </ServicesProvider>
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <div className="min-h-screen flex items-center justify-center bg-primary">
          <div className="text-center px-4">
            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-8">
              Welcome to EAIGLE's Deployment Version Dashboard
            </h1>
            <LoginButton />
          </div>
        </div>
      </UnauthenticatedTemplate>
    </>
  );
}

export default App;
